import { getDocs } from 'firebase/firestore/lite'
import React, { useEffect, useState } from 'react'
import { reqList } from '../../firebase.config'
import LoadingAdmin from '../extra/LoadingAdmin'

function ListingRequests() {

   const [reqData, setReqData] = useState([])
   async function getRequests() {
       const data = await getDocs(reqList)
       const result = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        console.log(result)
        setReqData(result)
    }

    useEffect(()=>{
        getRequests()
        console.log('on')
    },[])

  return (
    <div className='px-14'>
        {reqData.length!==0? 
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                          <th scope="col" className="p-4">
                              <div className="flex items-center">0</div>
                          </th>
                          <th scope="col" className="px-6 py-3 max-w-6">
                              User
                          </th>
                          <th scope="col" className="px-6 py-3 max-w-6">
                              Date
                          </th>
                          <th scope="col" className="px-6 py-3">
                              Request
                          </th>
                          <th scope="col" className="px-6 py-3">
                              Instruction
                          </th>
                          
                      </tr>
                  </thead>
                  <tbody>
                      {reqData.map((req, index) => (
                          <tr
                              className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                              key={index}
                          >
                              <td className="w-4 p-4">
                                  <div className="flex items-center">
                                      <p>{index + 1}</p>
                                  </div>
                              </td>
                              <td
                                  className="px-6 py-4 text-gray-900  dark:text-cyan-50"
                              >
                                  <span className="font-medium tracking-wider">
                                      {req.email}
                                  </span>
                                  <br />
                                  <span className="font-normal text-slate-400">
                                      {req.id}
                                  </span>
                              </td>
                              <td
                                  className="px-6 py-4 text-gray-900  dark:text-slate-200"
                              >
                                  <span className="font-normal text-lime-200">
                                      {req.date.toDate().toLocaleString()}
                                  </span>
                              </td>

                              <td className="px-6 py-4">
                                  <span className="font-normal text-emerald-300">
                                      <a href={req.image} target='popup'>OpenImage</a>
                                  </span>
                                  <br />
                                  <span className="font-normal text-purple-400">
                                      {req.link? <a href={req.link} target='_blank' rel='noreferrer'>GotoLink</a>  :"N/A"}
                                  </span>
                              </td>
                              <td className="px-6 py-4">
                                  <span className="font-normal text-yellow-300">
                                      {req.instruction? req.instruction: "N/A"}
                                  </span>
                              </td>
                          </tr>
                      ))}
                  </tbody>
              </table>
          </div>
              : <div className=''><LoadingAdmin/></div> }
      </div>
  )
}

export default ListingRequests